import React from 'react';
import PropTypes from 'prop-types';

import Button from './button.react';

/**
 * A SegmentedControl is a linear set of two or more segments, each of which functions as a mutually
 * exclusive button [1]. Each of the segments is an equal width and the control expands to fill the
 * width of its parent container.
 *
 * [1]: https://developer.apple.com/ios/human-interface-guidelines/ui-controls/segmented-controls/
 */
export const SegmentedControl = ({ segments, selectedSegment, onSelectedSegment }) => (
  <div className="SegmentedControl">
    {
      segments.map(({ title, value }) => (
        <Button
          className="SegmentedControl-button"
          modifiers={ value === selectedSegment ? ['primaryFilled'] : [] }
          onClick={ () => onSelectedSegment(value) }
          style={{ width: `${ 100 / segments.length }%` }}
          key={ value }
        >
          { title }
        </Button>
      ))
    }
  </div>
);

SegmentedControl.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  selectedSegment: PropTypes.string.isRequired,
  onSelectedSegment: PropTypes.func.isRequired,
};
